module.exports = __webpack_public_path__ + "media/application/images/2018/star-grey@4x-260cfc6735e666ee433ed61759d07f24.png";